module.exports = __webpack_public_path__ + "media/images/pic/brodno/teenagers-bc9fb72be6eebe7b1c73e13de5a92b00.svg";